export default __webpack_public_path__ + "static/favicon-fb2fb92b0bfa0e534368249a75e78591.ico";